module.exports = __webpack_public_path__ + "static/media/BannerD4.7fd7740a.png";